const ConnectSeller = ({glid, mobileNo}) => {

    function rc4(str) {
        var s = [], j = 0, x, res = '';
        var key = '1996c39iil';
        for (var i = 0; i < 256; i++) {
            s[i] = i;
        }
        for (i = 0; i < 256; i++) {
            j = (j + s[i] + key.charCodeAt(i % key.length)) % 256;
            x = s[i];
            s[i] = s[j];
            s[j] = x;
        }
        i = 0;
        j = 0;
        for (var y = 0; y < str.length; y++) {
            i = (i + 1) % 256;
            j = (j + s[i]) % 256;
            x = s[i];
            s[i] = s[j];
            s[j] = x;
            res += String.fromCharCode(str.charCodeAt(y) ^ s[(s[i] + s[j]) % 256]);
        }
        res = btoa(res);
        var res1 = encodeURIComponent(res);
        return res1;
    }
    
    const urlParams = new URLSearchParams(window.location.search);
    const empid = urlParams.get('empid');
    const number = urlParams.get('phone') || "";
    const crtObjId = urlParams.get('crtObjectId') || "";
    
    const iframeURL = () => {
        const ctcid = ""
       const url =  'https://vendors.intermesh.net/buyer-call-for-supplier.php?empid=' + rc4(empid) + '&searchno=' + rc4(number) + '&cno=' + rc4(mobileNo) + '&usrtyp=1&crtObjId=' + rc4(crtObjId) + '&glid=' + rc4(glid) + '&ctcID=' + rc4(ctcid);
       return url
    }
    
    return (
        <>
            <div>
                <iframe
                    src={iframeURL()}
                    title="Connect Seller UI"
                    style={{width:'100%', height:'800px', border:'none', marginTop:'450px'}}
                />
            </div>
        </>
    )
}

export default ConnectSeller;
